
/*
 * BUILD @athena/forge v9.0.0
 * THIS IS AN AUTOGENERATED FILE
 */

import React from 'react';
import IconBase from '../_IconBase';
const Collapse = props => {
  const modClassName = props.className;

  return (
    <IconBase viewBox="0 0 25 25" {...props} className={ modClassName }>
      <g>
        <g className="fe_c_icon__background">
          <rect width="25" height="25"></rect>
        </g>
        <g className="fe_c_icon__icon fe_c_icon__icon--primary">
          <polygon points="18 16 12.5 10.6 7 16 6 15 12.5 8.4 19 15 18 16"></polygon>
        </g>
      </g>
    </IconBase>);
};

Collapse.defaultProps = {
  title: 'Collapse',
};

export default Collapse;
